import React from "react";

export const MiniMapNode = ({ x, y }: { x: number; y: number }) => (
  <rect
    width="128"
    height="64"
    x={x}
    y={y}
    rx="16"
    ry="16"
    fill="#4d6670"
  />
);
